/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const PROPERTY_ASSETS_CONTROL_SUBMODULE_SLUG = "property-assets-control";
export const PROPERTY_ASSETS_SUBMODULE_SLUG = "property-assets";
